import * as React from 'react'
import { Button } from '../ui/button'
import { Input } from '../ui/input'
import { Label } from '../ui/label'
import FlashAlert from './FlashAlert'
import SocialAuthButtons from './SocialAuthButtons'

interface IProps {
	title: string
	emailLabel: string
	emailFieldName: string
	emailValue?: string
	passwordLabel: string
	passwordFieldName: string
	submitLabel: string
	continueWithLabel: string
	microsoftAuthUrl: string
	googleAuthUrl: string
	alreadyHaveAccountLabel: string
	logInLabel: string
	logInUrl: string
	flashMessage?: string
	flashType?: string
}

export default function SignupFormFields({
	title,
	emailLabel,
	emailFieldName,
	emailValue,
	passwordLabel,
	passwordFieldName,
	submitLabel,
	continueWithLabel,
	microsoftAuthUrl,
	googleAuthUrl,
	alreadyHaveAccountLabel,
	logInLabel,
	logInUrl,
	flashMessage,
	flashType,
}: IProps) {
	return (
		<div className="flex flex-col gap-6">
			<div className="flex flex-col items-center gap-2 text-center">
				<h1 className="text-2xl font-bold">{title}</h1>
			</div>

			<FlashAlert message={flashMessage} type={flashType} />

			<div className="flex flex-col gap-2">
				<Label htmlFor="user_email">{emailLabel}</Label>
				<Input
					id="user_email"
					name={emailFieldName}
					type="email"
					defaultValue={emailValue}
					autoComplete="off"
					required
				/>
			</div>

			<div className="flex flex-col gap-2">
				<Label htmlFor="user_password">{passwordLabel}</Label>
				<Input id="user_password" name={passwordFieldName} type="password" autoComplete="off" required />
			</div>

			<Button type="submit" className="w-full">
				{submitLabel}
			</Button>

			<SocialAuthButtons
				continueWithLabel={continueWithLabel}
				microsoftAuthUrl={microsoftAuthUrl}
				googleAuthUrl={googleAuthUrl}
			/>

			<p className="text-center text-sm text-muted-foreground">
				{alreadyHaveAccountLabel}{' '}
				<a href={logInUrl} className="underline underline-offset-4">
					{logInLabel}
				</a>
			</p>
		</div>
	)
}
